'use client';

import { useCallback, useEffect, useState } from "react";
import { useAccountsCtx, errText } from "../internals";

export const useAccountsData = () => {
  const { storage } = useAccountsCtx();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setError(null);
    try {
      setAccounts(await storage.listAccounts());
    } catch (e) {
      setError(errText(e));
    } finally {
      setLoading(false);
    }
  }, [storage]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { accounts, loading, error, refresh };
};
